/** Keep in sync with loyaltap-backend/src/shared/utils/marketingEmailSocialLinks.js */

export const MARKETING_SOCIAL_PLATFORMS = [
    { field: 'facebook_url', icon: 'facebook', label: 'Facebook' },
    { field: 'instagram_url', icon: 'instagram', label: 'Instagram' },
    { field: 'twitter_url', icon: 'x', label: 'X' },
    { field: 'linkedin_url', icon: 'linkedin', label: 'LinkedIn' },
];

/** Internal slug; rendered as mdi:earth (globe) in emails and preview. */
export const WEBSITE_ICON = 'world';
const SIMPLE_ICONS_COLOR = 'EDE9FE';

export function normalizeMarketingHttpUrl(raw) {
    if (!raw || typeof raw !== 'string') {
        return null;
    }
    const trimmed = raw.trim();
    if (!trimmed || trimmed === '—' || trimmed === '-') {
        return null;
    }
    try {
        const withProto = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
        const parsed = new URL(withProto);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return null;
        }
        return parsed.toString();
    } catch {
        return null;
    }
}

/**
 * @param {Record<string, string | null | undefined>} settings
 * @returns {Array<{ url: string, icon: string, label: string }>}
 */
export function collectMarketingSocialLinks(settings = {}) {
    const links = [];
    const website = normalizeMarketingHttpUrl(settings.website);
    if (website) {
        links.push({ url: website, icon: WEBSITE_ICON, label: 'Website' });
    }
    for (const platform of MARKETING_SOCIAL_PLATFORMS) {
        const url = normalizeMarketingHttpUrl(settings[platform.field]);
        if (url) {
            links.push({ url, icon: platform.icon, label: platform.label });
        }
    }
    return links;
}

export function marketingSocialIconImageUrl(iconSlug) {
    if (iconSlug === WEBSITE_ICON) {
        return `https://api.iconify.design/mdi/earth.svg?color=%23${SIMPLE_ICONS_COLOR}&width=28&height=28`;
    }
    return `https://cdn.simpleicons.org/${encodeURIComponent(iconSlug)}/${SIMPLE_ICONS_COLOR}`;
}
